import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

import CartAccountInfoPage from './CartAccountInfoPage';
import CartConfirmationPage from './CartConfirmationPage';
import CartPaymentPage from './CartPaymentPage';
import CartViewPage from './CartViewPage';
import ErrorHandler from '../../_molecules/ErrorHandler';

const CartPages = () => {
    const match = useRouteMatch();

    return (
        <ErrorHandler>
            <Switch>
                <Route path={`${match.path}/view`}>
                    <CartViewPage />
                </Route>

                <Route path={`${match.path}/account-info/:memberId`}>
                    <CartAccountInfoPage />
                </Route>

                <Route path={`${match.path}/payment`}>
                    <CartPaymentPage />
                </Route>

                <Route path={`${match.path}/confirmation`}>
                    <CartConfirmationPage />
                </Route>

                <Route path="*">
                    <Redirect to="/cart/view" />
                </Route>
            </Switch>
        </ErrorHandler>
    );
};

export default CartPages;
